module.exports = __webpack_public_path__ + "img/picaso-logo.207429c3.png";